import { MenuItem, Typography } from '@mui/material';
import { DownloadIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';

type Props = {
  disabled?: boolean;
  onClick: () => void;
};

export const DownloadOption = ({ disabled = false, onClick }: Props) => {
    const { t } = useTranslation();
  return (
    <MenuItem
      component='button'
      disabled={disabled}
      onClick={onClick}
      sx={{
        display: 'flex',
        gap: '14px',
        width: '100%',
        paddingLeft: '21px',
        paddingRight: '21px',
      }}
    >
      <DownloadIcon />
      <Typography>{t('interface:admin.download_floorplan')}</Typography>
    </MenuItem>
  );
};
